import React from "react";
import styled from "styled-components";
import {Button, Grid} from "@material-ui/core";
import RefreshIcon from "@material-ui/icons/Refresh";
import SectionView from "../../../Common/Views/SectionView";

interface RefreshButtonProps {
    onClick: () => void;
}

const RefreshButton = styled(Button)`
  width: calc(50% - 18px);
  left: 50%;
  transform: translate(-50%, 0);
  height: 46px;
`;

const RefreshButtonView = (props: RefreshButtonProps) => {
    const {onClick} = props;

    return (
       <SectionView>
            <RefreshButton
                variant={'outlined'}
                startIcon={<RefreshIcon />}
                onClick={onClick}
            >
                Refresh Page
            </RefreshButton>
       </SectionView>
    );
};

export default RefreshButtonView;